module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00005-fs8.4f53d1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00005-fs8.png
// module id = 159
// module chunks = 0